export default __webpack_public_path__ + "static/media/Encuesta_top.d90e5417.jpg";